module.exports = __webpack_public_path__ + "img/11.5a26b142.jpg";